// export const BASE_URL = "http://localhost:3001/api";
// export const CDN_BASE_URL = "http://localhost:3001/";

export const BASE_URL = "https://api.ariyanashop.com/api";
export const CDN_BASE_URL = "https://api.ariyanashop.com/";

// export const CDN_BASE_URL = "http://localhost:3001/";
// export const BASE_URL = "http://localhost:3001/api";
